import React, { useEffect, useMemo, useState } from "react"
import Select from "react-select"
import { INTEGRATION_KEY, INTEGRATION_LABEL } from "../../state/integration/Constants"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { FeatureContactExport } from "../../state/integration/IntegrationFeatureKeys"
import { BulkExportProps, SelectOption } from "../../common/types"
import { INTEGRATIONS_SUPPORTING_BULK_EXPORT } from "../../utils/automation/bulk"


const BulkExport = (props: BulkExportProps) => {
    const [selectedOption, setSelectedOption] = useState<SelectOption<INTEGRATION_KEY> | null>(null)

    const options = useMemo(() => AppContext.getIntegrationsByFeature(FeatureContactExport).filter((integration) =>
        INTEGRATIONS_SUPPORTING_BULK_EXPORT.includes(integration.attributes.integrationKey)).map((integration) => {
        return {
            value: integration.attributes.integrationKey,
            label: INTEGRATION_LABEL[integration.attributes.integrationKey]
        }
    }), [])

    useEffect(() => {
        props.onDisable(!selectedOption)
    }, [selectedOption])


    const onchange = (selectedOption: SelectOption<INTEGRATION_KEY>) => {
        setSelectedOption(selectedOption)
        props.onChange( {
            integrationKey: selectedOption.value
        })
    }

    return (
        <div>
            <Select
                options={options}
                onChange={onchange}
                value={selectedOption}
            />

        </div>
    )
}

export default BulkExport


// WEBPACK FOOTER //
// ./src/bulk/operations/BulkExport.tsx